module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/characters/ian_pointing_left.png
// module id = 2339
// module chunks = 2